import React, { useMemo } from 'react'
import {
  isMobile,
  browserName,
  isAndroid,
  isIOS,
  isTablet,
} from 'react-device-detect'
import BtnCopyUrl from './BtnCopyUrl'
import TestBtn from './test/TestBtn'
import { imgAppWrapper } from '../data/images'

const { appLogo } = imgAppWrapper

const AppWrapper: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const wrapperStyle = useMemo(() => {
    const width = window.innerWidth
    const height = window.innerHeight
    if (width >= (height * 3) / 4 || isTablet) {
      // 寬螢幕
      return { width: (height / 16) * 9, height }
    } else {
      // 長螢幕
      return {
        width,
        minHeight: (width / 9) * 16,
        display: 'flex',
        // alignItems: 'center',
      }
    }
  }, [])

  const isEligibleDevice =
    (isMobile || isTablet) && (isAndroid || isIOS)
  const isEligibleBrowser = /chrome|safari|samsung/i.test(browserName)
  const isLine = /line/i.test(browserName)

  if (!isEligibleDevice) {
    return (
      <div style={wrapperStyle}>
        <div className="center">
          <h2 style={{ color: '#fff' }}>
            This device is not supported
          </h2>
          <br />
          <h3 style={{ color: '#fff' }}>
            Please open this web in mobile devices
          </h3>
        </div>
      </div>
    )
  }
  if (isLine || !isEligibleBrowser) {
    return (
      <div style={wrapperStyle}>
        <div className="center" style={{}}>
          <img
            src={appLogo}
            style={{ width: 150, height: 150 }}
            alt="puzzle-logo"
          />
          <div style={{ marginTop: 20 }} />
          <h2
            style={{
              color: '#fff',
              lineHeight: 1.5,
              textAlign: 'center',
            }}
          >
            This browser is not supported
            <br />
            Please open this web in Safari or Chrome
          </h2>
          <BtnCopyUrl />
        </div>
      </div>
    )
  }

  return (
    <div style={wrapperStyle}>
      {children}

      {/* 測試用按鈕！ 以下待改！*/}
      {/* for testing */}
      {/* <TestBtn /> */}
    </div>
  )
}

export default AppWrapper
